import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { obtenerCampanas } from '../../../actions/CampanasAction';
import {
  Container,
  Typography,
  TextField,
  Button,
  CircularProgress,
  Paper,
  Box,
  Chip,
  InputAdornment,
} from '@mui/material';
import {
  Search as SearchIcon,
  Campaign as CampaignIcon,
  Add as AddIcon,
} from '@mui/icons-material';
import TCampanas from './TCampanas.js';
export default function CampanasPrincipal(props) {
  const mounted = useRef(true);
  const [Data, setData] = useState([]);
  const [term, setTerm] = useState('');
  const [datosCargados, setDatosCargados] = useState(false);

  useEffect(() => {
    if (mounted.current) {
      obtenerCampanas().then((response) => {
        console.log('Respuesta de obtenerCampanas:', response);
        if (response.status === 200) {
          setData(response.data);
          setDatosCargados(true);
        } else {
          console.log('NO CARGO NADA');
        }
      });
    }
    return function cleanup() {
      mounted.current = false;
    };
  }, []);
  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      {/* Header */}
      <Paper
        elevation={0}
        sx={{
          background: 'linear-gradient(135deg, #1976d2 0%, #0d47a1 100%)',
          borderRadius: 2,
          p: 3,
          mb: 3,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Box
              sx={{
                width: 56,
                height: 56,
                borderRadius: 2,
                background: 'rgba(255,255,255,0.2)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backdropFilter: 'blur(10px)',
              }}
            >
              <CampaignIcon sx={{ fontSize: 32, color: 'white' }} />
            </Box>
            <Box>
              <Typography variant="h4" sx={{ color: 'white', fontWeight: 600, mb: 0.5 }}>
                Campañas de Marketing
              </Typography>
              {datosCargados && (
                <Chip
                  label={`${Data.length} campañas`}
                  size="small"
                  sx={{
                    backgroundColor: 'rgba(255,255,255,0.2)',
                    color: 'white',
                    fontWeight: 500,
                    backdropFilter: 'blur(10px)',
                  }}
                />
              )}
            </Box>
          </Box>
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            component={Link}
            to="/nuevaCampana"
            sx={{
              backgroundColor: 'white',
              color: '#0d47a1',
              fontWeight: 600,
              px: 3,
              py: 1.5,
              borderRadius: 2,
              textTransform: 'none',
              fontSize: '1rem',
              boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
              '&:hover': {
                backgroundColor: 'rgba(255,255,255,0.9)',
                transform: 'translateY(-2px)',
                boxShadow: '0 6px 16px rgba(0,0,0,0.2)',
              },
              transition: 'all 0.3s ease',
            }}
          >
            Nueva Campaña
          </Button>
        </Box>
      </Paper>

      {/* Search Bar */}
      <Paper
        elevation={0}
        sx={{
          p: 3,
          mb: 3,
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 2,
        }}
      >
        <TextField
          fullWidth
          variant="outlined"
          placeholder="Buscar campañas por descripción, empresa o geografía..."
          name="term"
          value={term}
          onChange={(e) => setTerm(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon color="action" />
              </InputAdornment>
            ),
          }}
          sx={{
            '& .MuiOutlinedInput-root': {
              borderRadius: 2,
              backgroundColor: 'background.default',
              transition: 'all 0.3s ease',
              '&:hover': {
                backgroundColor: 'action.hover',
              },
              '&.Mui-focused': {
                backgroundColor: 'background.paper',
              },
            },
          }}
        />
      </Paper>

      {/* Content */}
      <Paper
        elevation={0}
        sx={{
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 2,
          overflow: 'hidden',
        }}
      >
        {datosCargados ? (
          <TCampanas rows={Data} termc={term} history={props.history} />
        ) : (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              py: 8,
              gap: 2,
            }}
          >
            <CircularProgress size={48} thickness={4} />
            <Typography variant="h6" color="text.secondary">
              Cargando campañas...
            </Typography>
          </Box>
        )}
      </Paper>
    </Container>
  );
}
